export class CouncilResolutionStatus {
    id: number;
    councilResolutionStatus1: string;
    status: boolean;
}